// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"fcc32602","301":"258acfac"}[chunkId] + ".chunk.js";
};